import * as React from "react";
import * as moment from "moment";

export interface IPatientNotesOOC {
    notes: string,
    doctorName: string,
    recordedDate: any,
    tenant: string
}

export interface PatientNotesOOCCardProps {
    patientNotesOOC: IPatientNotesOOC
}

const PatientNotesOOCCard = (props: PatientNotesOOCCardProps) => {
    return (
        <div className={"patient-notes-ooc-card"}>
            <div className={"patient-notes-ooc-notes"}>
                {props.patientNotesOOC.notes}
            </div>
            <div className={"patient-notes-ooc-added-by-doctor-name-and-time"}>
                <div className={"patient-notes-ooc-added-by"}>
                    ADDED BY
                </div>
                <div className={"patient-notes-ooc-added-by-doctor-name"}>
                    {props.patientNotesOOC.doctorName}
                </div>
                <div className={"patient-notes-ooc-recorded-time"}>
                    at {moment(props.patientNotesOOC.recordedDate).format("hh:mm A")}
                </div>
            </div>

        </div>
    )
}

export default PatientNotesOOCCard;